import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import ILoginResponse from '@sunbit-dev/common/models/cardApply/ILoginResponse';
import IApplicationError from '@sunbit-dev/common/models/IApplicationError';
import { Actions } from '../actions/identificationActions';
import { ActionTypes } from '../models/actions/identification';

export interface IIdentificationState extends Partial<ILoginResponse> {
  type?: ActionTypes;
  status?: ActionStatus;
  error?: IApplicationError;
}

const initialState: IIdentificationState = {};

export default function identificationReducer(state = initialState, action: Actions): IIdentificationState {
  switch (action.type) {
    case ActionTypes.Identify:
      return { ...state, ...action };
    default:
      return state;
  }
}
